import React from "react";
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { EntityIdParams } from "models/propTypes/urlParamsTypes";
//#endregion
//#region components
import {
  PageLayouts,
  useMountedState,
  useNavigationHistory,
  RouteBreadCrumb,
  useAPIRequestKeyRef,
} from "components/common";
import { useParams } from "react-router-dom";
import { ErrorView } from "components/error";
import ReceiptViewInner from "./viewInner";
import { useReceiptService } from "serviceHooks";
//#endregion

const ReceiptView: React.FC = () => {
  const receiptService = useReceiptService();
  const { getMounted } = useMountedState();
  const urlParams = useParams<EntityIdParams>();
  const receiptId = Number.parseInt(urlParams.id ?? "0");

  const [loading, setLoading] = React.useState(true);
  const [receipt, setReceipt] = React.useState<WintSuperkollAPIModel.Receipt>();
  const [notFound, setNotFound] = React.useState<boolean>();
  const [key, setKey] = React.useState(0);

  const { goBack } = useNavigationHistory();

  const { apiRequestKeyRef, updateKey } = useAPIRequestKeyRef();

  const loadReceipt = (
    receiptId: number,
    onSuccess?: (receipt: WintSuperkollAPIModel.Receipt) => void,
    onError?: () => void
  ) => {
    const currentKey = updateKey();

    receiptService
      .get(receiptId, currentKey)
      .then((result) => {
        if (getMounted() && result.key === apiRequestKeyRef.current) {
          setNotFound(false);
          setReceipt(result);
          setKey(key + 1);
        }
        onSuccess && onSuccess(result);
      })
      .catch(() => {
        if (receipt) {
          setTimeout(() => {
            goBack();
          }, 1000);

          onError && onError();
        } else {
          setNotFound(true);
        }
      })
      .finally(() => setLoading(false));
  };

  React.useEffect(() => {
    if (receiptId) {
      if (receipt?.id !== receiptId) {
        setLoading(true);
        setReceipt(undefined);
        loadReceipt(receiptId);
      }
    } else {
      setReceipt(undefined);
      setLoading(false);
    }
  }, [urlParams]);

  return notFound ? (
    <ErrorView />
  ) : (
    <PageLayouts.EntityFullScreen
      entityKey={`receipt`}
      id={receipt?.id ?? 0}
      navigation={<RouteBreadCrumb current={loading ? "" : receipt?.createdByPersonName ?? ""} showHome />}
    >
      <ReceiptViewInner key={receiptId} receipt={receipt} loadReceipt={loadReceipt} reloadKey={key} />
    </PageLayouts.EntityFullScreen>
  );
};

export default ReceiptView;
